import { ErrorContext } from '@portals/shared-frontend/hooks';
import { useContext, useEffect } from 'react';

export function NotFoundPage() {
  const { setGlobalError } = useContext(ErrorContext);

  useEffect(() => {
    setGlobalError(404);
  }, [setGlobalError]);

  return null;
}
